import {currDate} from '../utils/date';
import GoogleMapsApi from './map/GoogleMapsApi';
import {getLocOptions, getMenuOptions, getOption} from '../utils/option';
import {initMapEl, renderMap} from './map/gMap';
import {EventPopUp} from '../A4map/popUp/eventPopUp';
import { addVenues, getQueryStr } from './marker/getMarkerData';
import { debug } from '../../../config';
import $ from 'jquery';
import http from '../services/http';
/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */
//Add class method for get marker data, pass this
export class A4map {
  constructor(options = {}) {
    A4map.get = this;
    this.debug = getOption(options, 'debug', true);
    this.loc = getLocOptions(options);
    this.zoom = getOption(options, 'zoom', 10);
    this.mapId = getOption(options, 'mapId', undefined);
    this.date = getOption(options, 'date', currDate());
    this.gApiKey = getOption(options, 'gApiKey', undefined);
    this.a4ApiKey = getOption(options, 'a4ApiKey', undefined);
    this.geolocation = getOption(options, 'geolocation', true);
    this.popUpId = getOption(options, 'popUpId', undefined);
    this.popUp = getOption(options, 'popUp', undefined);
    this.menuOptions = getMenuOptions(options);
    this.fromPowersearch = false;
    // options not configurable by user
    this.map = undefined;
    this.markers = [];
    this.infowindow = null;
    this.gMarker = undefined;
    this.widgetID = getOption(options, 'widgetId', 1);
    //Powersearch Filters
    this.distance = getOption(options, 'distance', 25);
    this.minDate = undefined;
    this.maxDate = undefined;
    this.genre = undefined;
    this.bounds =  getOption(options, 'bounds', undefined);
    this.subscriber = getOption(options, 'subscriber', undefined);
    this.initIds();
  }
  init() {
 //  document.addEventListener('DOMContentLoaded', (event) => {
      if (document.querySelector(this.mapId)) {
        if (this.menuOptions) {
          // if (this.menuOptions.search) {
          //   this.getSearchHtml();

          //   console.log('has search');
          // }
          //mak new function for below event Pop Up
          if (this.menuOptions.eventPopUp) {
            window.PopUp = new EventPopUp({
              widgetID: this.widgetID,
              popUpId: this.popUpId,
            });
            debug && console.log(document.querySelector('.hearby-event-detail-overlay'));
            document.querySelector('.hearby-event-detail-overlay').innerHTML = `
              <div class="${this.popUpId.substring(1)} hearby-map-inner-popup-${this.widgetID}">
                <a class="close">×</a>
                <div class="content">
                </div>
              </div>
          `;
            window.PopUp.init();
          }
        }
        const mapEl = initMapEl(this.mapId);
        const gmapApi = new GoogleMapsApi(this.gApiKey);
        // Call map renderer
          gmapApi.load().then(() => {
          renderMap(this, mapEl);
        //  this.setMapMarkers();
        });
        
}
//});
  }

  initIds() {
    this.popUpId = '.event_popup-' + this.widgetID;
    this.mapId = '.hearby-map-' + this.widgetID;
    debug && console.log('ids set', this);
  }
  async setMapMarkers() {
    const queryStr = getQueryStr(this);
     return await http.get(
          queryStr,
          false).then((data) => {
           addVenues(data, this);
          });
      
    
}
  changeLocation(lat, lng) {
      this.loc.lat = lat;
      this.loc.lng = lng;
      this.map.setCenter({lat: lat, lng: lng});
      // setTimeout(function(){
      //   this.fromPowersearch = false; 
      //   }, 500);
      
      this.setMapMarkers();
  }

  setInitialLocation(lat, lng) {
    this.loc.lat = lat;
    this.loc.lng = lng;
    this.map.setCenter({lat: lat, lng: lng});
    // setTimeout(function(){
    //   this.fromPowersearch = false; 
    //   }, 500);
    
    this.setMapMarkers();
    this.fromPowersearch = true;
}
}
